import { useQuery } from "@tanstack/vue-query";
import Billing from "@/services/billing/billing";

export interface TrialStatusData {
  type?: "stripe_subscription" | "free_trial" | "none";
  status?: string;
  trialEndsAt?: string | null;
  daysRemaining?: number;
}

export function useTrialStatus() {
  return useQuery({
    queryKey: ["billing", "trialStatus"] as const,
    queryFn: async (): Promise<TrialStatusData | null> => {
      const result = await Billing.getTrialStatus();
      const payload = result?.data as { status?: boolean; data?: TrialStatusData };
      if (payload?.status && payload?.data != null) return payload.data;
      return null;
    },
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
